package com.tovtalk.data.local

import com.tovtalk.utils.logger.Logger
import kotlinx.browser.localStorage

private const val KEY_TOKEN = "auth_token"
private const val KEY_REFRESH_TOKEN = "refresh_token"

/**
 * Call from Web main() so every token save also writes to localStorage.
 */
fun initTokenManagerWebPersistence() {
    TokenManager.onTokensPersisted = { access, refresh ->
        if (access != null) localStorage.setItem(KEY_TOKEN, access) else localStorage.removeItem(KEY_TOKEN)
        if (refresh != null) localStorage.setItem(KEY_REFRESH_TOKEN, refresh) else localStorage.removeItem(KEY_REFRESH_TOKEN)
    }
}

/**
 * On Web, StorageSettings (russhwolf) might use a different storage or key scheme.
 * Read from localStorage directly and populate TokenManager so session persists across refresh.
 */
actual fun syncTokenManagerFromStorageIfNeeded() {
    if (TokenManager.accessToken != null) return
    val access = localStorage.getItem(KEY_TOKEN)
    val refresh = localStorage.getItem(KEY_REFRESH_TOKEN)
    if (!access.isNullOrBlank()) {
        Logger.d("TokenManagerSync: loading tokens from localStorage (accessToken present)", "TokenManagerSync")
        TokenManager.accessToken = access
        if (!refresh.isNullOrBlank()) {
            TokenManager.refreshToken = refresh
        }
    }
}
